import { registerComponent } from "helpers";
import { WYATTPreferredStores } from "wyatt";

registerComponent(
  "preferred-store-button",
  class PreferredStoreButton extends WYATTPreferredStores {
    constructor() {
      super();

      this.makePreferred = this.querySelector("[data-make-preferred]");
      this.isPreferred = this.querySelector("[data-is-preferred]");

      if (!this.makePreferred || !this.isPreferred) {
        return;
      }

      this.makePreferred.removeAttribute("disabled");
      this.makePreferred.addEventListener("click", this.handleClick.bind(this));

      this.update();
    }

    handleClick(event) {
      event.preventDefault();

      window.localStorage.setItem(
        WYATT.config.preferredStore.localStorageKey,
        this.config.storeID,
      );

      this.publish(
        WYATT.PubSub.events.preferredStoreChange,
        this.config.storeID,
      );
    }

    update() {
      // super() subscribed this instance to preferredStoreChange, which calls
      // update() on every store change regardless of the constructor's guard -
      // so re-check the elements here too, not just at construction.
      if (!this.makePreferred || !this.isPreferred) {
        return;
      }

      if (this.config.storeID === this.preferredStoreID) {
        this.makePreferred.classList.add("hidden");
        this.isPreferred.classList.remove("hidden");
      } else {
        this.makePreferred.classList.remove("hidden");
        this.isPreferred.classList.add("hidden");
      }
    }
  },
);
